import { useFlags } from 'launchdarkly-react-client-sdk';

export const useReleaseAssortmentIAFlag = () => {
  const { releaseAssortmentIa } = useFlags();
  return !!releaseAssortmentIa;
};
